
  import { defineComponent } from 'vue';

  export default defineComponent({
    emits: ['shown'],
    setup(_, { emit }) {
      emit('shown');
    },
  });
